module.exports = __webpack_public_path__ + "1248c10c8484e56810f394bf8b242bc2.png";